import { lazy } from "react";

export const CookieNoticeWrapper = lazy(() => import("./CookieNoticeWrapper"));
